import React, { useEffect, useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faServer, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import AdminLayout from "./AdminLayout";
import "./admin.css";

function adminFetch(path, opts = {}) {
  const token = localStorage.getItem("adminToken");
  return fetch(path, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", ...(opts.headers || {}) },
  });
}

function fmt(s) {
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${h}h ${m}m ${sec}s`;
}

export default function AdminSystem() {
  const [info,    setInfo]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState("");

  const load = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const res  = await adminFetch("/api/admin/system");
      const data = await res.json();
      if (res.ok) setInfo(data);
      else          setError(data.message || "Failed to load system info.");
    } catch {
      setError("Unable to reach server.");
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <AdminLayout pageTitle="System Info">
      <div style={{ marginBottom: "1rem", display: "flex", justifyContent: "flex-end" }}>
        <button className="adm-btn ghost" onClick={load} disabled={loading}>
          <FontAwesomeIcon icon={faSyncAlt} spin={loading} />
          Refresh
        </button>
      </div>

      {error && <div className="adm-alert error">{error}</div>}

      {info && !loading && (
        <div className="adm-card" style={{ maxWidth: 480 }}>
          <div className="adm-card-header">
            <h3>
              <FontAwesomeIcon icon={faServer} style={{ marginRight: ".5rem" }} />
              Server Status
            </h3>
            <span className="adm-badge approved">Online</span>
          </div>
          <div className="adm-card-body">
            <div className="adm-kv-row"><span className="adm-kv-label">Uptime</span><span className="adm-kv-value">{fmt(info.uptime_seconds)}</span></div>
            <div className="adm-kv-row"><span className="adm-kv-label">Heap Used</span><span className="adm-kv-value">{info.heap_used_mb} MB</span></div>
            <div className="adm-kv-row"><span className="adm-kv-label">Heap Total</span><span className="adm-kv-value">{info.heap_total_mb} MB</span></div>
            <div className="adm-kv-row"><span className="adm-kv-label">RSS</span><span className="adm-kv-value">{info.rss_mb} MB</span></div>
            <div className="adm-kv-row"><span className="adm-kv-label">Node.js</span><span className="adm-kv-value"><code style={{ fontSize: ".85rem" }}>{info.node_version}</code></span></div>
            <div className="adm-kv-row"><span className="adm-kv-label">Environment</span><span className="adm-kv-value"><code style={{ fontSize: ".85rem" }}>{info.env}</code></span></div>
            <div className="adm-kv-row"><span className="adm-kv-label">Snapshot time</span><span className="adm-kv-value" style={{ fontSize: ".78rem" }}>{new Date(info.timestamp).toLocaleString()}</span></div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
